import React, {useRef, useState} from 'react';
import BackgroundImage from '../../assets/parental_bg.png';
import StarBackground from '../../assets/parental_stars.png';
import ConfettiBackground from '../../assets/bg_confetti.png';
import CharactersBackground from '../../assets/bg_welcome_characters.png';
import styled from 'styled-components';
import {getCurrentLang} from '../../utils/i18n';
import SizzleVideoES from '../../assets/videos/cnito-sizzle-es.mp4';
import SizzleVideoPT from '../../assets/videos/cnito-sizzle-pt.mp4';

import {
    mobileMediaQuery,
    notWebMediaQuery,
    tabletMediaQuery,
} from '../../styles';
import {useTranslation} from 'react-i18next';
import ThumbnailImage from '../../assets/sizzle-preview.png';

const Welcome = () => {
    const {t} = useTranslation();

    const videoRef = useRef(null);

    const [showThumbnail, setShowThumbnail] = useState(true);

    const playVideo = () => {
        videoRef.current.play();
        setShowThumbnail(false);
    };

    return (
        <Container>
            <ContentStack>
                <SizzleReel>
                    <Thumbnail
                        onClick={playVideo}
                        showThumbnail={showThumbnail}
                        alt="play"
                    >
                        <PlayImage
                            src={require('../../assets/bt_play_big.png')}
                            alt="play"
                        />
                    </Thumbnail>
                    <video
                        width="100%"
                        height="100%"
                        controls
                        loop
                        ref={videoRef}
                    >
                        <source
                            src={
                                getCurrentLang() === 'pt'
                                    ? SizzleVideoPT
                                    : SizzleVideoES
                            }
                            type="video/mp4"
                        />
                        Your browser does not support the video tag.
                    </video>
                </SizzleReel>
                <TextHolder>
                    <HomeText>{t('parentalPage.welcome.title')}</HomeText>
                    <HomeSubtitle>
                        {t('parentalPage.welcome.subtitle')}
                    </HomeSubtitle>
                </TextHolder>
            </ContentStack>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    background-image: url(${CharactersBackground}), url(${ConfettiBackground}),
        url(${StarBackground}), url(${BackgroundImage});
    background-position: center -30px, center 0px, center 10px, 0px -10px;
    background-color: white;
    background-repeat: no-repeat, no-repeat, no-repeat, repeat;
    flex-direction: column;
    margin-top: 60px;
    ${mobileMediaQuery} {
        margin-top: 100px;
    }

    ${tabletMediaQuery} {
        margin-top: 120px;
    }
`;

const ContentStack = styled.div`
    flex-direction: row;
    display: flex;
    padding: 80px 24px 154px 24px;
    max-width: 1200px;
    align-self: center;
    align-items: center;

    ${mobileMediaQuery} {
        padding: 16px 24px;
        flex-direction: column;
    }

    ${tabletMediaQuery} {
        padding: 16px 24px;
        flex-direction: column;
    }
`;

const TextHolder = styled.div`
    flex: 1;
    margin-left: 80px;
    max-width: 300px;
    ${notWebMediaQuery} {
        margin-left: 0px;
        max-width: 500px;
        padding: 12px 0px;
    }
`;

const HomeText = styled.div`
    font-family: 'Rodger';
    font-weight: 700;
    font-size: 50px;
    color: white;
    text-transform: uppercase;

    ${notWebMediaQuery} {
        font-size: 28px;
        margin-top: 12px;
        font-weight: 900;
    }
`;

const HomeSubtitle = styled.p`
    font-family: 'Oduda';
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    color: white;
    line-height: 22px;

    ${notWebMediaQuery} {
        font-size: 15px;
        font-weight: 300;
    }
`;

const SizzleReel = styled.div`
    background: white;
    border-radius: 18px;

    border: 10px solid white;
    flex: 1;
    max-width: 528px;
    position: relative;

    video {
        border-radius: 12px;
        overflow: hidden;
        margin-bottom: -4px;
    }

    ${notWebMediaQuery} {
        border: 5px solid white;
        border-radius: 8px;
        video {
            border-radius: 5px;
        }
    }
`;

const Thumbnail = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
    border-radius: 12px;
    display: flex;
    ${props => !props.showThumbnail && `display: none;`}
    cursor: pointer;
    align-items: center;
    justify-content: center;
    background-image: url(${ThumbnailImage});
    background-size: cover;

    ${notWebMediaQuery} {
        border-radius: 5px;
    }
`;

const PlayImage = styled.img`
    ${notWebMediaQuery} {
        width: 45px;
    }
`;

export default Welcome;
